/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useEffect, useRef, useState } from 'react';
import { Button, DatePicker, Form, Input, InputNumber, Message, Select, Space, Upload } from '@arco-design/web-react';
import { IconDelete } from '@arco-design/web-react/icon';
import dayjs from 'dayjs';
import './index.scss';
import { post ,get } from '../requestNew';
import { API_CONFIG } from '../utils';
import { Item, Option, StockOrder } from './types';
const FormItem = Form.Item;

const formItemLayout = {
  labelCol: {
    span: 8
  },
  wrapperCol: {
    span: 16
  }
};

function Order() {
  const [form] = Form.useForm<StockOrder>();
  const [formBase] = Form.useForm<StockOrder>();
  // const [sessionList, setSessionList] = useState<{ label: string; value: string }[]>([]);
  const [gameSession, setGameSession] = useState('');
  const [sessionList, setSessionList] = useState<Option[]>([]);
  const [loading, setLoading] = useState(false);
  const [userList, setUserList] = useState<Item[]>([]);
  const [disabled, setDisabled] = useState(true);
  const [openId, setOpenId] = useState('');
  const [picture, setPicture] = useState<{ url: string }[]>([]);
  const [sessionTimeMap, setSessionTimeMap] = useState<any>([]);
  const [curRang, setCurRang] = useState<{ gameEndTime: string; gameStartTime: string }>({
    gameEndTime: '',
    gameStartTime: ''
  });

  const gameNameRef = useRef('');
  const groupTypeRef = useRef(101);
  const getUser = (gameSession: string) => {
    get(`/sys/umsUserQualifications/getUserList`,  { gameSession })
      .then((res: any) => {
        const { code, data = [], message } = res || {};
        if (code === 200) {
          const list = (data.records || data || [])
            .filter((item: Item) => item.orderStatus === 'SUCCESS')
            .map((item: Item) => {
              const { openId, gameName } = item;
              return { ...item, value: openId, label: gameName };
            });

          setUserList(list);
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      });
  };

  const getData = (openId: string) => {
    const holdDate = formBase.getFieldValue('holdDate');

    const params = {
      holdDate,
      openId,
      gameSession
    };
    get(`/sys/umsExplodeOrder/getExplodeOrderDetail`,  params )
      .then((res: any) => {
        const { code, data } = res || {};
        if (code === 200 && data?.orderDetails) {
          const { orderDetails = {}, orderPicVos = [] } = data || {};
          setDisabled(true);
          setPicture(orderPicVos);
          form.setFieldsValue({ ...orderDetails });
        } else {
          setDisabled(false);
          setPicture([]);
          form.resetFields();
        }
      })
      .catch(() => {
        Message.error('网络错误！');
      });
  };

  const submit = () => {
    const holdDate = formBase.getFieldValue('holdDate');
    form
      .validate()
      .then(formData => {
        const holdStockVos = formData.holdStockVos || [];
        const data: any = {
          ...formData,
          holdDate,
          openId,
          gameSession,
          holdStockVos,
          isFront: 0,
          nickname: 'nickname',
          picType: '1',
          gameName: gameNameRef.current,
          groupType: groupTypeRef.current,
          orderPicVos: picture
        };

        post(`/sys/umsExplodeOrder/dealExplodeOrder`, data)
          .then((res: any) => {
            const { code, message } = res || {};
            if (code === 200) {
              Message.success('提交成功！');
              setDisabled(true);
            } else {
              Message.error(message);
            }
          })
          .catch(() => {
            Message.error('网络错误！');
          });
      })
      .catch(() => {
        Message.error('字段填写不完整，请核对后再次提交！');
      });
  };

  const userChange = (val: string) => {
    setPicture([]);
    form.resetFields();
    const cur = userList.find(user => user.openId === val);

    const { gameName = '', groupType = 0 } = cur || {};
    gameNameRef.current = gameName;
    groupTypeRef.current = groupType;
    if (!groupType) {
      Message.error('数据错误，请联系开发排查');
      setDisabled(true);
      return;
    }

    setOpenId(val);
    getData(val);
  };

  const resetForm = () => {
    setPicture([]);
    form.resetFields();
    gameNameRef.current = '';
  };

  const sessionChange = (val: string) => {
    getUser(val);
    setCurRang(sessionTimeMap[val]);
    setGameSession(val);
    resetForm();
    formBase.setFieldValue('gameName', '');
    setOpenId('');
    if (dayjs().isBefore(sessionTimeMap[val].gameEndTime)) {
      formBase.setFieldValue('holdDate', dayjs().format('YYYY-MM-DD'));
    } else {
      formBase.setFieldValue('holdDate', dayjs(sessionTimeMap[val].gameEndTime).format('YYYY-MM-DD'));
    }
  };
  const dateChange = () => {
    resetForm();
    if (openId) {
      userChange(openId);
    }
  };

  const filterOption = (inputValue: string, option: any) => {
    if (inputValue) {
      return (option.props?.children || '').includes(inputValue);
    } else {
      return true;
    }
  };

  const uploadChange = (fileList: any[]) => {
    const list = fileList.map(item => {
      return {
        url: item.url || item.response?.data || ''
      };
    });
    setPicture(list);
  };

  const analysis = () => {
    setLoading(true);
    post(`/common/imageIdentify`, picture[0])
      .then((res: any) => {
        const { code, message, data } = res || {};
        if (code === 200) {
          const { totalAssets, stockPercent ,  todayProfitLoss} = data;
          const holdStockVos = data.holdStockVos || [];
          holdStockVos.forEach((item: any) => {
            item.type = item.profitAndLossPrice;
            item.holdPrice = item.holdPrice || '';
            item.profitAndLossPrice = item.profitAndLossPrice || '';
            item.stockName = item.stockName || '';
          });
          // 没识别出数据情况
          if (totalAssets === null) {
            Message.error('识别出错！');
          } else {
            form.setFieldsValue({ totalAssets, holdStockVos, stockPercent, todayProfitLoss });
            Message.success('识别完成！');
          }
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误！');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {

    get('/gameConfig/getUmsGameConfigList').then((res: any) => {
      if (res && res.data ) {
        const sessionMap: Record<string, { gameEndTime: string; gameStartTime: string }> = {};

        const list = res && res.data 
          // .filter(item => item.gameStatus == '1' || item.gameStatus == '2')
          .map((item: any) => {
            const { gameSession, gameSessionName, gameEndTime, gameStartTime } = item;
            sessionMap[gameSession] = { gameEndTime, gameStartTime };
            return { label: gameSessionName, value: gameSession };
          });
        const gameSession = list[0].value;

        setSessionList(list);
        setGameSession(gameSession);
        getUser(gameSession);
        setSessionTimeMap(sessionMap);
        setCurRang(sessionMap[gameSession]);
        formBase.setFieldValue('gameSession', gameSession);
        formBase.setFieldValue('holdDate', dayjs().format('YYYY-MM-DD'));
      }
    });
  }, []);

  return (
    <div className="order">
      <Form form={formBase} autoComplete="off" {...formItemLayout}>
        <FormItem label="赛季" field="gameSession">
          <Select
            options={sessionList}
            onChange={sessionChange}
            showSearch
            filterOption={(inputValue, option) =>
              option.props.children.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
            }
          />
        </FormItem>
        <FormItem label="日期" field="holdDate">
          <DatePicker
            style={{ width: '100%' }}
            onChange={dateChange}
            disabledDate={current =>
              current.isBefore(curRang.gameStartTime) ||
              current.isAfter(curRang.gameEndTime) ||
              dayjs().isBefore(current)
            }
          />
        </FormItem>
        <FormItem label="参赛名" field="gameName">
          <Select options={userList} onChange={userChange} showSearch filterOption={filterOption} />
        </FormItem>
      </Form>
      <Form form={form} autoComplete="off" {...formItemLayout}>
        <Form.Item label="上传截图">
          <Form.Item noStyle field="orderPicVos" triggerPropName="fileList" rules={[{ required: true }]}>
            <Upload
              listType="picture-card"
              imagePreview
              multiple
              action={API_CONFIG.uploadUrl}
              onChange={uploadChange}
            />
          </Form.Item>
          <Button
            className="analysis"
            type="primary"
            status="danger"
            loading={loading}
            disabled={!picture.length}
            onClick={analysis}
          >
            分析
          </Button>
        </Form.Item>

        <FormItem label="今日总资产" field="totalAssets" rules={[{ required: true }]}>
          <InputNumber hideControl />
        </FormItem>
        <FormItem label="今日收益率" field="todayEarningRate">
          <InputNumber hideControl suffix="%" />
        </FormItem>
        <FormItem label="仓位" field="stockPercent">
          <InputNumber hideControl suffix="%" />
        </FormItem>
        <FormItem label="今日盈亏" field="todayProfitLoss">
          <InputNumber hideControl />
        </FormItem>
        <FormItem label="总收益率" field="totalEarningRate">
          <InputNumber hideControl suffix="%" />
        </FormItem>

        <FormItem style={{ marginBottom: 0 }} label="持仓列表" className="stock-list">
          <Form.List field="holdStockVos">
            {(fields, { add, remove }) => {
              return (
                <div>
                  {fields.map((item, index) => {
                    return (
                      <div key={item.key}>
                        <FormItem>
                          {index === 0 && (
                            <div>
                              <Space style={{ color: '#666' }}>
                                <FormItem noStyle>
                                  <div style={{ width: 150 }}>股票名称</div>
                                </FormItem>
                                <FormItem noStyle>
                                  <div style={{ width: 150 }}>持仓(元)</div>
                                </FormItem>
                                {/* <FormItem noStyle>
                                    <div style={{ width: 150 }}>盈亏(万)</div>
                                  </FormItem> */}
                                <FormItem noStyle>
                                  <Button
                                    style={{ opacity: 0 }}
                                    icon={<IconDelete />}
                                    shape="circle"
                                    status="danger"
                                  ></Button>
                                </FormItem>
                              </Space>
                            </div>
                          )}
                          <Space>
                            <FormItem field={item.field + '.stockName'} rules={[{ required: true }]} noStyle>
                              <Input style={{ width: 150 }} />
                            </FormItem>
                            <FormItem field={item.field + '.holdPrice'} rules={[{ required: true }]} noStyle>
                              <Input style={{ width: 150 }} />
                            </FormItem>
                            <Button
                              icon={<IconDelete />}
                              shape="circle"
                              status="danger"
                              onClick={() => remove(index)}
                            ></Button>
                          </Space>
                        </FormItem>
                      </div>
                    );
                  })}
                  <FormItem>
                    <Button
                      onClick={() => {
                        add();
                      }}
                    >
                      添加
                    </Button>
                  </FormItem>
                </div>
              );
            }}
          </Form.List>
        </FormItem>
        <FormItem label=" ">
          <Button className="btn" type="primary" disabled={disabled} onClick={() => submit()}>
            提交
          </Button>
        </FormItem>
      </Form>
    </div>
  );
}

export default Order;
